import { useRecoilState } from 'recoil'
import {
  statusState,
  questionIndexState,
  resultIndexState,
  answerHistoryState,
} from 'atoms'
import { Status, Answer } from 'enums'
import routes from 'routes'

const useAnalysis = () => {
  const [status, setStatus] = useRecoilState(statusState)
  const [questionIndex, setQuestionIndex] = useRecoilState(questionIndexState)
  const [resultIndex, setResultIndex] = useRecoilState(resultIndexState)
  const [answerHistory, setAnswerHistory] = useRecoilState(answerHistoryState)

  // * ページ数
  const questionCnt = routes.questions.length
  const resultCnt = routes.results.length

  // * 質問番号
  const questionNumber = answerHistory.length + 1

  // * 診断スタート
  const start = () => {
    setStatus(Status.IN_PROGRESS)
    setQuestionIndex(0)
  }

  // * 次の質問へ移動
  const moveToNextQuestion = (answer: Answer, index: number) => {
    if (index < questionCnt) {
      // 回答履歴を更新
      setAnswerHistory((oldAnswerHistory) => [
        ...oldAnswerHistory,
        [questionIndex, answer],
      ])

      // 次の質問へ移動
      setQuestionIndex(index)
    } else {
      console.error('遷移先の質問は存在しません!')
    }
  }

  // * 診断結果を表示
  const showResult = (index: number) => {
    if (index < resultCnt) {
      setStatus(Status.DONE)
      setResultIndex(index)
    } else {
      console.error('遷移先の診断結果は存在しません!')
    }
  }

  // * TOPへ戻る
  const backToTop = () => {
    setStatus(Status.NOT_YET)

    // ! 回答履歴をクリア
    setAnswerHistory([])
  }

  // * 前の画面へ戻る
  const backToPrevQuestion = () => {
    setAnswerHistory((oldAnswerHistory) =>
      oldAnswerHistory.slice(0, oldAnswerHistory.length - 1)
    )
    setQuestionIndex(answerHistory.slice(-1)[0][0])
  }

  // * 最初からやり直す
  const restart = () => {
    setQuestionIndex(0)

    // ! 回答履歴をクリア
    setAnswerHistory([])
  }

  return {
    status,
    questionIndex,
    resultIndex,
    answerHistory,
    questionNumber,
    start,
    moveToNextQuestion,
    showResult,
    backToTop,
    backToPrevQuestion,
    restart,
  }
}

export default useAnalysis
